export class StateFilter  {

    readonly ALABAMA : string = "AL";
    readonly ALASKA : string = "AK";
    readonly ARIZONA : string = "AZ";
    readonly ARKANSAS : string = "AR";
    readonly CALIFORNIA : string = "CA";
    readonly COLORADO : string = "CO";
    readonly CONNECTICUT : string = "CT";
    readonly DELAWARE : string = "DE";
    readonly DISTRICT_OF_COLUMBIA : string = "DC";
    readonly FLORIDA : string = "FL";
    readonly GEORGIA : string = "GA";
    readonly HAWAII : string = "HI";
    readonly IDAHO : string = "ID";
    readonly ILLINOIS : string = "IL";
    readonly INDIANA : string = "IN";
    readonly IOWA : string = "IA";
    readonly KANSAS : string = "KS";
    readonly KENTUCKY : string = "KY";
    readonly LOUISIANA : string = "LA";
    readonly MAINE : string = "ME";
    readonly MARYLAND : string = "MD";
    readonly MASSACHUSETTS : string = "MA";
    readonly MICHIGAN : string = "MI";
    readonly MINNESOTA : string = "MN";
    readonly MISSISSIPPI : string = "MS";
    readonly MISSOURI : string = "MO";
    readonly MONTANA : string = "MT";
    readonly NEBRASKA : string = "NE";
    readonly NEVADA : string = "NV";
    readonly NEW_HAMPSHIRE : string = "NH";
    readonly NEW_JERSEY : string = "NJ";
    readonly NEW_MEXICO : string = "NM";
    readonly NEW_YORK : string = "NY";
    readonly NORTH_CAROLINA : string = "NC";
    readonly NORTH_DAKOTA : string = "ND";
    readonly OHIO : string = "OH";
    readonly OKLAHOMA : string = "OK";
    readonly OREGON : string = "OR";
    readonly PENNSYLVANIA : string = "PA";
    readonly RHODE_ISLAND : string = "RI";
    readonly SOUTH_CAROLINA : string = "SC";
    readonly SOUTH_DAKOTA : string = "SD";
    readonly TENNESSEE : string = "TN";
    readonly TEXAS : string = "TX";
    readonly UTAH : string = "UT";
    readonly VERMONT : string = "VT";
    readonly VIRGINIA : string = "VA";
    readonly WASHINGTON : string = "WA";
    readonly WEST_VIRGINIA : string = "WV";
    readonly WISCONSIN : string = "WI";
    readonly WYOMING : string = "WY";

    //US Territories
    readonly US_TERRITORY_AMERICAN_SAMOA : string = "AS";
    readonly US_TERRITORY_FEDERATED_STATES_OF_MICRONESIA : string = "FM";
    readonly US_TERRITORY_GUAM : string = "GU";
    readonly US_TERRITORY_MARSHALL_ISLANDS : string = "MH";
    readonly US_TERRITORY_N_MARIANA_ISLANDS : string = "MP";
    readonly US_TERRITORY_PALAU : string = "PW";
    readonly US_TERRITORY_PUERTO_RICO : string = "PR";
    readonly US_TERRITORY_VIRGIN_ISLANDS : string = "VI";
}